import React from 'react';

import Box from '@mui/material/Box';

import { Iconify } from 'src/components/iconify';

export const currencyLocaleMap: Record<string, string> = {
  SAR: 'ar-SA',
  INR: 'hi-IN',
  USD: 'en-US',
  EUR: 'fr-FR',
  GBP: 'en-GB',
};

export function getCurrencySymbol(currencyCode?: string): string {
  if (!currencyCode) return 'SAR';
  const code = currencyCode.toUpperCase();
  if (code === 'USD' || code === '$') return '$';
  if (code === 'EUR' || code === '€') return '€';
  if (code === 'GBP' || code === '£') return '£';
  if (code === 'SAR' || code === 'ر.س') return 'SAR';
  try {
    const locale = currencyLocaleMap[code] || 'en';
    const formatted = (0).toLocaleString(locale, {
      style: 'currency',
      currency: code,
      minimumFractionDigits: 0,
      maximumFractionDigits: 0,
    });
    return formatted.replace(/[\d.,\s]/g, '').trim() || code;
  } catch {
    return code;
  }
}

interface CurrencySymbolProps {
  currency?: string;
  sx?: any;
  width?: number | string;
}

export function CurrencySymbol({ currency = 'SAR', sx, width = 18 }: CurrencySymbolProps) {
  const code = (currency || 'SAR').toUpperCase();
  if (code === 'SAR' || code === 'ر.س') {
    return <Iconify icon="lucide-saudi-riyal" width={width} sx={sx} />;
  }
  const symbol = getCurrencySymbol(code);
  return (
    <Box
      component="span"
      sx={{
        fontWeight: 'bold',
        display: 'inline-flex',
        alignItems: 'center',
        lineHeight: 1,
        ...sx,
      }}
    >
      {symbol}
    </Box>
  );
}
